import type { FC, ReactNode } from 'react'

import { motion } from 'motion/react'
import { cn } from '@/lib/utils'

interface BrandRuleProps {
    className?: string
    trigger?: 'view' | 'mount'
    delay?: number
}

// The segmented underline of the Markus Balle logo: orange, light grey, dark grey, orange
const SEGMENTS = [
    { grow: 30, className: 'bg-brand' },
    { grow: 11, className: 'bg-logo-light' },
    { grow: 27, className: 'bg-logo-dark' },
    { grow: 29, className: 'bg-brand' }
]

export const BrandRule: FC<BrandRuleProps> = ({ className, trigger = 'view', delay = 0 }): ReactNode => {
    const animateProps = trigger === 'mount'
        ? { animate: { scaleX: 1 } }
        : { whileInView: { scaleX: 1 }, viewport: { once: true, margin: '0px 0px -8% 0px' } }

    return (
        <div aria-hidden='true' className={cn('flex h-[3px] w-full gap-[1.2%]', className)}>
            {SEGMENTS.map((segment, index) => (
                <motion.span
                    key={index}
                    className={cn('block h-full origin-left', segment.className)}
                    style={{ flexGrow: segment.grow, flexBasis: 0 }}
                    initial={{ scaleX: 0 }}
                    transition={{ duration: 1.1, delay: delay + index * 0.12, ease: [0.16, 1, 0.3, 1] }}
                    {...animateProps}
                />
            ))}
        </div>
    )
}
